
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import EventItem1 from "@/components/items/event/EventItem1.vue";

@Component({
  components: {
    EventItem1,
  },
  filters,
})
export default class Events4 extends Vue {
  @Prop({ default: [] })
  private events!: Array<any>;
}
